const timestampToPubNubTimetoken = (timestamp: number): string =>
  `${timestamp}0000`;

export default timestampToPubNubTimetoken;
